/* eslint-disable @typescript-eslint/no-explicit-any */
import { switchMap, first } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { fromPaymentMethodsActions, PaymentMethodsState, paymentMethodsQuery } from '../../+state';

/**
 * Gets AutoTopUpBundle for manage-auto-top-up screen
 */
@Injectable()
export class AutoTopUpBundleResolver {
  constructor(private _store: Store<PaymentMethodsState>) {}

  /*
   * Resolve AutoTopUpBundle
   * 1. Selects getAutoTopUpBundle from the store
   * 3. Check if autoTopUpBundle is present
   * - If state is empty:
   *   1. Call getAutoTopUpBundle
   * 4. Return balance from store.
   */
  public resolve(): Observable<any> {
    return this._store.select(paymentMethodsQuery.getAutoTopUpBundle).pipe(
      switchMap(() => {
        // TODO
        // for now we cannot use cached data
        // there is no delta sync/realtime infrastructure
        this.getAutoTopUpBundle();

        return of(true);

        // if (!autoTopUpBundle) {
        //   return this.getAutoTopUpBundle();
        // }
        // return of(autoTopUpBundle);
      }),
      first()
    );
  }

  /*
   * trigger fetching autoTopUpBundle
   * 1. Dispatch getAutoTopUpBundle action
   * 2. Listening to setAutoTopUpBundle
   */
  private getAutoTopUpBundle() {
    this._store.dispatch(fromPaymentMethodsActions.getAutoTopUpBundle());
  }
}
